import React from 'react';
import PropTypes from 'prop-types';
import findByString from "../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import {makeStyles, Tooltip} from "@material-ui/core";
import {Menu} from "@material-ui/icons";

const useStyles = makeStyles(() => ({
    buttonGroupIcon: {
        height: 27,
        padding: 0,
        borderRadius: 0,
        border: "1px solid !important",
        margin: "0 5px",
        borderColor: "#cbcbcb !important"
    },
}));

const FlexDirection = ({label, path, setValue, values}) => {
    const classes = useStyles();
    const value = findByString(values, path);

    function onChange(e, v) {
        v && setValue(v, path)
    }

    return (
        <div style={{display: 'flex', marginTop: 5, alignItems: 'center'}}>
            <div style={{width: 102}}>
                {label}
            </div>
            <ToggleButtonGroup
                size={"small"}
                exclusive
                value={value}
                onChange={onChange}
                aria-label="content alignment">
                <ToggleButton size={"small"} value="column" aria-label="column" className={classes.buttonGroupIcon}>
                    <Tooltip title={'Column'}>
                        <Menu style={{transform: "rotate(90deg)"}}/>
                    </Tooltip>
                </ToggleButton>
                <ToggleButton size={"small"} value="row" aria-label="row" className={classes.buttonGroupIcon}>
                    <Tooltip title={'Row'}>
                        <Menu/>
                    </Tooltip>
                </ToggleButton>
            </ToggleButtonGroup>
        </div>
    )
};

FlexDirection.propTypes = {
    label: PropTypes.string,
    path: PropTypes.string,
    setValue: PropTypes.func,
    values: PropTypes.object
};

export default FlexDirection;